import Severity from './Severity';

export default {
  [Severity.MINOR]: 200,
  [Severity.MAJOR]: 50,
  [Severity.CRITICAL]: 0,
};
